function ChangeNumberErrorHandler(response = {}) {
  if (!(response && response.data)) return;
  const { data = {} } = response;
  const { error = {} } = data;
  const { httpCode: statusCode = "no-code", message = "", errorCode } = error;
  if (statusCode === 422 && errorCode === "LOGIN_NUMBER_ALREADY_IN_USE") {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "numero-login-em-uso",
          title: "Número de login em uso",
          message: `Esse número de celular já está sendo usado por você.`,
        },
      },
    };
  } else if (statusCode === 401) {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "sessao-expirada",
          title: "Sessão expirada",
          message: "Efetue o login novamente",
        },
      },
    };
  }else if (statusCode === 500) {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "ERRO-500",
          title: "Ops",
          message: `Ocorreu um erro inesperado! Por favor, tente novamente mais tarde.`,
          originalMessage: message,
          systemError: data,
        },
      },
    };
  } else {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "ERRO",
          title: "Ocorreu um erro inesperado!",
          message: "Verifique sua conexão com a internet e tente novamente",
          systemError: data,
        },
      },
    };
  }
}
export default ChangeNumberErrorHandler;
